const calculateInstantOrSameDayFee = (
  amount: Cents,
  feeConfig: API.InstantFeesResponse | null
): Dollars => {
  if (!feeConfig) {
    return 0 as Dollars;
  }

  const amountDollars = amount / 100;

  switch (feeConfig.kind) {
    case "free":
      return 0 as Dollars;
    case "fixed":
      return (feeConfig.max ?? 0) as Dollars;
    case "percent": {
      if (!feeConfig.percent) {
        return 0 as Dollars;
      }

      const rawFee = amountDollars * feeConfig.percent;
      if (feeConfig.max !== undefined && rawFee > feeConfig.max) {
        return feeConfig.max as Dollars;
      }
      if (feeConfig.min !== undefined && rawFee < feeConfig.min) {
        return feeConfig.min as Dollars;
      }

      return rawFee as Dollars;
    }
    default:
      return 0 as Dollars;
  }
};

export default calculateInstantOrSameDayFee;
